<template>
    <ux-form class="delPoint" ref="form" width="440px" :data="formData" :rules="rules" :colon="true" label-width="70px" data-automation="delPoint">
        <div class="ux-content-text">确定将删除本次查询的全部定位点?</div>
        <ux-form-item label="删除原因" start prop="reason">
            <ux-input v-model="formData.reason" type="textarea" show-word-limit :maxlength="50" :autosize="{minRows: 3, maxRows: 4}"></ux-input>
        </ux-form-item>
    </ux-form>
</template>

<script>
export default {
  data() {
    return {
      formData: {},
      rules: this.$rul.delPoint(),
    };
  },
};
</script>

<style lang="scss" scoped>
.delPoint {
    .ux-content-text {
        padding-bottom: 20px;
    }
}
</style>
